import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-secure-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  password: string;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
 

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.form = new FormGroup({
  //    newPassword: new FormControl(null, [Validators.required,  Validators.pattern('((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.maxLength(30), Validators.minLength(8)]),
  //    password: new FormControl(null, [Validators.required,  Validators.maxLength(30), Validators.minLength(8)])

    newPassword: new FormControl(null, [Validators.required, Validators.minLength(8), Validators.maxLength(30),
      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,30}')
    ]),
    password: new FormControl(null, [Validators.required, Validators.minLength(8), Validators.maxLength(30),
      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,30}')
    
    ])
    
    });
  }

  onSubmit() {
    console.log("Function Call");
//    console.log(this.form.value.password, this.form.value.newPassword);
    if (this.form.valid) {
      if(this.form.value.password === this.form.value.newPassword){
        console.log(this.form.value.password, this.form.value.newPassword);
        this.save();
      }
      else{
        this.errorToast("Password and Confirm Password do not match");
      }
    } 
    else {
        this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
    .updatePassword(this.form.value.password)
    .subscribe(({status, errorMessage}) => {
        if(status === 'SUCCESS') {
          this.successToast();
          setTimeout(() => {
            this.router.navigate(["/secure", "home"]);
          }, 2000);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });  
  }

  async successToast() {
    await this._snackBar.open(
      "User saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}